<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Vision and Mission</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="javascript:void(0);">Vision and Mission</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="vision-mission ptb--100">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="mb-3">
          <h4 class="mt-3 fw-bold">V<span class="yellow-color">ision</span></h4>
          <p>To achieve excellent standards of quality education by keeping pace with rapidly changing technologies and
            create technical manpower of global standards with capabilities of accepting new challenges.</p>
        </div>
        <hr>
        <div class="my-3">
          <h4 class="mt-3 fw-bold">M<span class="yellow-color">ission</span></h4>
          <p>Our efforts are dedicated to impart quality and value based education to raise satisfaction level of all
            stakeholders. Our strength is directed to create competent professionals. Our endeavour is to provide all
            possible support to promote research and development activities.</p>
        </div>
      </div>
    </div>
  </div>
</section>
